
import React, { useEffect, useLayoutEffect, useState } from 'react';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import AddInputs from '../../components/Add/AddInputs';
import AddModel from '../../components/Add/AddModel';
import AddBottomButton from '../../components/Add/AddBottomButton';
import { addMNOtypes, payload } from './components/types';
import validateMandatoryFields from '../../components/commonfunctions/validateMandatoryFields';
import useApi from '../../services/useApi';
import { showToast } from '../../components/toastMessage/toastSlice';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RootState } from '../../store';
import { useSelector } from 'react-redux';
import { convertDate } from '../../components/commonfunctions/convertDate';
import { getChangedFields } from '../../components/commonfunctions/getChangedKeys';
import deepEqual from '../../components/commonfunctions/deepEqual';
import useTranslation from '../../components/CustomHooks/useTranslation';
import { inputFieldContent } from '../../components/inputfields/InputFieldContent';

interface addMNOPropsTypes {
  edit?: boolean;
}
const AddMNO: React.FC = ({ edit = false }: addMNOPropsTypes) => {
  const initialErrorState = {
    name: "",
    contract_start_date: "",
    contract_end_date: "",
    min_recharge_amount: "",
    max_recharge_amount: "",
    office_no: "",
    market_block_name: "",
    floor_no: "",
    street_name: "",
    city_town: "",
    country: "",
    province: "",
    region: "",
    district: "",
    postal_code: "",
    etopup_upfront_fee_percent: "",
    etopup_target_fee_percent: "",
    etopup_principal_fee_percent: "",
    etopup_dispersive_fee_percent: "",
    bundle_upfront_fee_percent: "",
    bundle_target_fee_percent: "",
    bundle_principal_fee_percent: "",
    bundle_dispersive_fee_percent: "",
    etopup_from_date: "",
    etopup_to_date: "",
    etopup_target_value: "",
    bundle_from_date: "",
    bundle_to_date: "",
    bundle_target_value: "",
  }
  const initialState: addMNOtypes = {
    subnet: '',
    name: "",
    contract_start_date: "",
    contract_end_date: "",
    min_recharge_amount: '',
    max_recharge_amount: '',
    office_no: "",
    market_block_name: "",
    floor_no: "",
    street_name: "",
    city_town: "",
    country: "",
    province: "",
    region: "",
    district: "",
    postal_code: "",
    etopup_upfront_fee_percent: '',
    etopup_target_fee_percent: '',
    etopup_principal_fee_percent: '',
    etopup_dispersive_fee_percent: '',
    bundle_upfront_fee_percent: '',
    bundle_target_fee_percent: '',
    bundle_principal_fee_percent: '',
    bundle_dispersive_fee_percent: '',
    etopup_from_date: "",
    etopup_to_date: "",
    etopup_target_value: '',
    bundle_from_date: "",
    bundle_to_date: "",
    bundle_target_value: '',

  }
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [state, setState] = useState<addMNOtypes>(initialState);
  const [temporaryState, setTemporaryState] = useState<payload>({
    subnet: '',
    name: "",
    contract_start_date: "",
    contract_end_date: "",
    min_recharge_amount: 0,
    max_recharge_amount: 0,
    office_no: "",
    market_block_name: "",
    floor_no: "",
    street_name: "",
    city_town: "",
    country: "",
    province: "",
    region: "",
    district: "",
    postal_code: "",
    etopup_upfront_fee_percent: 0,
    etopup_target_fee_percent: 0,
    etopup_principal_fee_percent: 0,
    etopup_dispersive_fee_percent: 0,
    bundle_upfront_fee_percent: 0,
    bundle_target_fee_percent: 0,
    bundle_principal_fee_percent: 0,
    bundle_dispersive_fee_percent: 0,
    etopup_from_date: "",
    etopup_to_date: "",
    etopup_target_value: 0,
    bundle_from_date: "",
    bundle_to_date: "",
    bundle_target_value: 0,
  });
  const [disablingState, setDisablingState] = useState<addMNOtypes>(initialState);
  const [errors, setErrors] = useState(initialErrorState);
  const { notEnglish } = useTranslation(inputFieldContent)
  const { PostAPI, getAPI, PatchAPI } = useApi();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pathname = useSelector((state: RootState) => state.geolocation.previousUrl);
  const { id } = useParams();
  const [subnetList, setSubnetList] = useState()
  const MNODetailsinputs = {
    "": {
      "MNO Subnet": {
        required: false,
        disabled: (id && state?.subnet),
        id: "subnet",
        type: "dropDown",
        tabIndex: 0,
        placeholder: 'MNO Subnet',
        options: subnetList,
      },
      "MNO Name": {
        required: true,
        disabled: !!id,
        id: "name",
        type: "input",
        maxLength: 60,
        tabIndex: 0,
        placeholder: 'Enter MNO name'
      },
      "Contract Start Date": {
        required: true,
        disabled: false,
        id: "contract_start_date",
        type: "date",
        tabIndex: 0,
      },
      "Contract End Date": {
        required: true,
        disabled: false,
        id: "contract_end_date",
        type: "date",
        tabIndex: 0,
      },
      "Minimum Recharge Amount": {
        required: true,
        disabled: false,
        id: "min_recharge_amount",
        type: "input",
        maxLength: 60,
        tabIndex: 0,
        placeholder: 'Enter amount'
      },
      "Maximum Recharge Amount": {
        required: true,
        disabled: false,
        id: "max_recharge_amount",
        type: "input",
        maxLength: 60,
        tabIndex: 0,
        placeholder: 'Enter amount'
      },
    },
    "MNO Address": {
      "Office No.": {
        required: false,
        disabled: false,
        id: "office_no",
        type: "input",
        maxLength: 60,
        tabIndex: 7,
      },
      "Market/Block Name": {
        required: false,
        disabled: false,
        id: "market_block_name",
        type: "input",
        maxLength: 60,
        tabIndex: 5,
      },
      "Floor No.": {
        required: false,
        disabled: false,
        id: "floor_no",
        type: "input",
        maxLength: 60,
        tabIndex: 6,
      },
      "Street Name": {
        required: false, // Not a required field based on business logic
        disabled: false,
        id: "street_name",
        type: "input",
        maxLength: 60,
        tabIndex: 8,
      },
      Country: {
        required: false,
        disabled: false,
        id: "country",
        type: "country_type", // Adjust if needed
        tabIndex: 9,
      }
    }
  };
  const ServiceFeeDetailsinputs = {
    "eTop Up": {
      "Upfront Service Fee Percentage": {
        required: true,
        disabled: false,
        id: "etopup_upfront_fee_percent",
        type: "input",
        maxLength: 60,
        tabIndex: 0,
        percentage: true,
        placeholder: 'Enter percentage'
      },
      "On Target Achievement Service fee Percentage": {
        required: true,
        disabled: false,
        id: "etopup_target_fee_percent",
        type: "input",
        maxLength: 60,
        percentage: true,
        tabIndex: 0,
        placeholder: 'Enter percentage'
      },
      "Principal Service Fee Percentage": {
        required: true,
        disabled: true,
        id: "etopup_principal_fee_percent",
        type: "input",
        maxLength: 60,
        tabIndex: 0,
        percentage: true,
        placeholder: 'Percentage',
        secondaryText: 'Note : Calculated as Upfront + On Target Fee'
      },
      "Dispersive Service Fee Percentage (Postpaid)": {
        required: true,
        disabled: false,
        id: "etopup_dispersive_fee_percent",
        type: "input",
        maxLength: 60,
        tabIndex: 0,
        placeholder: 'Enter percentage'
      },
    },
    "Bundle Activation": {
      "Upfront Service Fee Percentage": {
        required: false,
        disabled: false,
        id: "bundle_upfront_fee_percent",
        type: "input",
        tabIndex: 7,
        maxLength: 60,
        placeholder: 'Enter percentage'
      },
      "On Target Achievement Service fee Percentage": {
        required: false,
        disabled: false,
        id: "bundle_target_fee_percent",
        type: "input",
        maxLength: 60,
        tabIndex: 5,
        placeholder: 'Enter percentage'
      },
      "Principal Service Fee Percentage": {
        required: false,
        disabled: true,
        id: "bundle_principal_fee_percent",
        type: "input",
        maxLength: 60,
        tabIndex: 6,
        placeholder: 'Percentage',
        secondaryText: 'Note : Calculated as Upfront + On Target Fee'
      },
      "Dispersive Service Fee Percentage (Postpaid)": {
        required: false, // Not a required field based on business logic
        disabled: false,
        id: "bundle_dispersive_fee_percent",
        type: "input",
        maxLength: 60,
        tabIndex: 8,
        placeholder: 'Enter percentage'
      },
    }
  };
  const MNOTargetDetails = {
    "eTop Up": {
      "From Date": {
        required: false,
        disabled: false,
        id: "etopup_from_date",
        type: "date",
        tabIndex: 0,
      },
      "To Date": {
        required: false,
        disabled: false,
        id: "etopup_to_date",
        type: "date",
        tabIndex: 0,
      },
      "eTop Up Target Value": {
        required: false,
        disabled: false,
        id: "etopup_target_value",
        type: "input",
        maxLength: 60,
        tabIndex: 0,
        placeholder: 'Enter amount'
      },
    },
    "Bundle Activation": {
      "From Date": {
        required: false,
        disabled: false,
        id: "bundle_from_date",
        type: "date",
        tabIndex: 0,
      },
      "To Date": {
        required: false,
        disabled: false,
        id: "bundle_to_date",
        type: "date",
        tabIndex: 0,
      },
      "Bundle Activation Target Value": {
        required: false,
        disabled: false,
        id: "bundle_target_value",
        type: "input",
        tabIndex: 0,
        maxLength: 60,
        placeholder: 'Enter amount'
      },
    }
  }


  //function to take the input values
  const handleInputChange = (id: string, value: string) => {
    // Define fields that should be validated for numeric values with up to two decimal places.
    const amountFields = [
      "max_recharge_amount",
      "min_recharge_amount",
      "etopup_target_value",
      "bundle_target_value",
    ];

    // Define fields that should be validated as percentages (0-100) with up to two decimal places.
    const percentFields = [
      "etopup_upfront_fee_percent",
      "etopup_target_fee_percent",
      "etopup_principal_fee_percent",
      "bundle_upfront_fee_percent",
      "bundle_target_fee_percent",
      "bundle_principal_fee_percent",
    ];
    const percentFIeldUnderprincipal = [

      "bundle_dispersive_fee_percent",
      "etopup_dispersive_fee_percent",
    ]

    // Validate numeric input for amount fields
    if (value !== "") {
      if (amountFields.includes(id) && !/^\d+(\.\d{0,2})?$/.test(value)) {
        return; // Prevent state update if input does not match the allowed format.
      }

      // Validate percentage fields (should be between 0 and 100, with up to two decimals)
      if (percentFields.includes(id) && value !== "" && !/^(?:100(?:\.0{0,2})?|0|(?:[0-9]?\d)?(?:\.\d{0,2})?)$/.test(value)) {
        return; // Prevent state update only for completely invalid inputs.
      }
      // Validate percentage fields (should be between 0 and 100, with up to two decimals)
      if (
        percentFIeldUnderprincipal.includes(id) &&
        value !== "" &&
        (!/^\d{1,3}(?:\.\d{0,2})?$/.test(value) || parseFloat(value) > 200)
      ) {
        return; // Prevent state update only for completely invalid inputs.
      }
    }

    // Convert value to number for amount and percentage fields
    let formattedValue: string | number = value;
    // if (amountFields.includes(id) || percentFields.includes(id)) {
    //   formattedValue = parseFloat(value) || 0;
    // }

    // Clear errors if the contract start or end date fields have errors.
    if ((id === "contract_start_date" || id === "contract_end_date") && errors.contract_start_date === " ") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        contract_end_date: "",
        contract_start_date: "",
      }));
    }

    // Handle calculation for `etopup_principal_fee_percent` based on the sum of related percentage fields.
    if (id === "etopup_upfront_fee_percent" || id === "etopup_target_fee_percent") {
      let principalAmount =
        Number(state.etopup_upfront_fee_percent || 0) +
        Number(state.etopup_target_fee_percent || 0) +
        (id === "etopup_upfront_fee_percent" ? parseFloat(value || '0') - Number(state.etopup_upfront_fee_percent || 0) : 0) +
        (id === "etopup_target_fee_percent" ? parseFloat(value || '0') - Number(state.etopup_target_fee_percent || 0) : 0);
      setState((prev) => ({
        ...prev,
        etopup_principal_fee_percent: principalAmount.toFixed(2).toString(),
      }));

    }
    // Calculate bundle principal fee percentage based on upfront and target fee changes
    if (id === "bundle_upfront_fee_percent" || id === "bundle_target_fee_percent") {
      let principalAmount =
        Number(state.bundle_upfront_fee_percent || 0) +
        Number(state.bundle_target_fee_percent || 0) +
        (id === "bundle_upfront_fee_percent" ? parseFloat(value || '0') - Number(state.bundle_upfront_fee_percent || 0) : 0) +
        (id === "bundle_target_fee_percent" ? parseFloat(value || '0') - Number(state.bundle_target_fee_percent || 0) : 0);
      setState((prev) => ({
        ...prev,
        bundle_principal_fee_percent: principalAmount.toFixed(2).toString(),
      }));
    }


    // Clear max recharge amount error when min/max recharge amounts are changed
    if (id === "max_recharge_amount" || id === "min_recharge_amount" && errors.max_recharge_amount === "Maximum recharge amount should be greater than minimum recharge amount") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        max_recharge_amount: ""
      }))
    }

    // Clear date validation errors when etopup from/to dates are changed
    if (id === "etopup_from_date" || id === "etopup_to_date" && errors.etopup_to_date === "'To Date' should be greater than the 'From Date'.") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        etopup_to_date: "",
        etopup_from_date: ""
      }))
    }

    // Clear error message for the specific field being updated.
    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: "",
    }));

    // Update the state with the new value for the input field.
    setState((prev) => ({
      ...prev,
      [id]: formattedValue,
    }));

  };

  // Function to handle form submission
  const handleSubmit = async () => {
    // Reset any previous error messages
    setErrors(initialErrorState);

    // Array of required field IDs that must be validated
    const requiredIds = [
      // Basic MNO details fields
      "name",
      "contract_start_date",
      "contract_end_date",
      "min_recharge_amount",
      "max_recharge_amount",

      // Required address fields
      "country",
      "postal_code",
      "region",
      "province",
      "district",

      // Required eTop Up service fee fields
      "etopup_upfront_fee_percent",
      "etopup_target_fee_percent",
      "etopup_principal_fee_percent",
      "etopup_dispersive_fee_percent",

    ];

    // Special handling for Afghanistan - district is only required for Afghanistan
    if (state?.country !== "Afghanistan") {
      // Find index of district field
      const index = requiredIds.indexOf("district");
      // Remove district from required fields if found
      if (index > -1) {
        requiredIds.splice(index, 1);
      }
    }

    // Initialize error flag to track validation errors
    let errorFlag: boolean = false;
    // Validate all required fields and get any error messages
    const errorObject = validateMandatoryFields(state, requiredIds);
    // If validation errors exist, display them and stop submission
    if (Object.keys(errorObject).length > 0) {
      errorFlag = true;
      setErrors({ ...initialErrorState, ...errorObject });
    }
    // Check if any eTopup fields are filled - if one is filled, all become required
    if (state?.etopup_from_date != "" || state?.etopup_to_date != "" || state?.etopup_target_value) {
      // Validate eTopup from date is provided
      if (state?.etopup_from_date == "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          etopup_from_date: "This field is required",
        }))
        errorFlag = true;
      }
      // Validate eTopup to date is provided  
      if (state?.etopup_to_date == "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          etopup_to_date: "This field is required",
        }))
        errorFlag = true;
      }
      // Validate eTopup target value is provided
      if (!state?.etopup_target_value) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          etopup_target_value: "This field is required",
        }))
        errorFlag = true;
      }
      // Validate that eTopup to date is after from date
      if (new Date(state.etopup_from_date) > new Date(state.etopup_to_date)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          etopup_from_date: " ",
          etopup_to_date: "'To Date' should be greater than the 'From Date'."
        }));
        errorFlag = true;
      }
    }

    // Check if any bundle fields are filled - if one is filled, all become required
    if (state?.bundle_from_date != "" || state?.bundle_to_date != "" || state?.bundle_target_value) {
      // Validate bundle from date is provided
      if (state?.bundle_from_date == "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          bundle_from_date: "This field is required",
        }))
        errorFlag = true;
      }
      // Validate bundle to date is provided
      if (state?.bundle_to_date == "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          bundle_to_date: "This field is required",
        }))
        errorFlag = true;
      }
      // Validate bundle target value is provided
      if (!state?.bundle_target_value) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          bundle_target_value: "This field is required",
        }))
        errorFlag = true;
      }
      // Validate that bundle to date is after from date
      if (new Date(state.bundle_from_date) > new Date(state.bundle_to_date)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          bundle_from_date: " ",
          bundle_to_date: "'To Date' should be greater than the 'From Date'."
        }));
        errorFlag = true;
      }
    }
    // Checks if the `errorFlag` is set to `true`. If so, it returns from the current function, preventing further execution.
    if (errorFlag) {
      return;
    }
    // Validates that the contract end date is greater than the contract start date. If the end date is less than or equal to the start date, it sets an error in the `errors` object and returns from the function, preventing further execution.
    if (new Date(state.contract_start_date) >= new Date(state.contract_end_date)) {
      setErrors({
        ...errors,
        contract_start_date: " ",
        contract_end_date: "'End Date' should be greater than the 'Start Date'."
      });
      return;
    }
    // Validates that the minimum recharge amount is greater than 0 and less than the maximum recharge amount. If the condition is not met, it sets an error in the `errors` object and returns from the function, preventing further execution.
    if (Number(state.min_recharge_amount) == 0 || Number(state.max_recharge_amount) == 0) {
      if (Number(state.min_recharge_amount) == 0) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          'min_recharge_amount': "Minimum recharge amount should be greater than 0"
        }));
        return;
      }
      if (Number(state.max_recharge_amount) == 0) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          'max_recharge_amount': "Maximum recharge amount should be greater than 0"
        }));
        return;
      }
    }
    if (Number(state.min_recharge_amount) > Number(state.max_recharge_amount)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        'max_recharge_amount': "Maximum recharge amount should be greater than minimum recharge amount"
      }));
      return;
    }


    // Validate that dispersive fee percentage is not greater than upfront fee percentage
    let dispersiveErrorFlag = false;
    if (Number(state?.etopup_dispersive_fee_percent) > Number(state?.etopup_principal_fee_percent)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        'etopup_dispersive_fee_percent': "Dispersive Service Fee % must be less than Principal Service Fee %."
      }));
      dispersiveErrorFlag = true
    }
    if (Number(state?.bundle_dispersive_fee_percent) > Number(state?.bundle_principal_fee_percent)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        'bundle_dispersive_fee_percent': "Dispersive Service Fee % must be less than Principal Service Fee %."
      }));
      dispersiveErrorFlag = true
    }

    if (dispersiveErrorFlag) {
      return;
    }

    // Create a copy of the current state as the API payload
    let payload: payload = {
      subnet: state?.subnet,
      name: state?.name,
      contract_start_date: state?.contract_start_date,
      contract_end_date: state?.contract_end_date,
      min_recharge_amount: Number(state?.min_recharge_amount),
      max_recharge_amount: Number(state?.max_recharge_amount),
      office_no: state?.office_no,
      market_block_name: state?.market_block_name,
      floor_no: state?.floor_no,
      street_name: state?.street_name,
      city_town: state?.city_town,
      country: state?.country,
      province: state?.province,
      region: state?.region,
      district: state?.district,
      postal_code: state?.postal_code,
      etopup_upfront_fee_percent: Number(state?.etopup_upfront_fee_percent),
      etopup_target_fee_percent: Number(state?.etopup_target_fee_percent),
      etopup_principal_fee_percent: Number(state?.etopup_principal_fee_percent),
      etopup_dispersive_fee_percent: Number(state?.etopup_dispersive_fee_percent),
      bundle_upfront_fee_percent: Number(state?.bundle_upfront_fee_percent),
      bundle_target_fee_percent: Number(state?.bundle_target_fee_percent),
      bundle_principal_fee_percent: Number(state?.bundle_principal_fee_percent),
      bundle_dispersive_fee_percent: Number(state?.bundle_dispersive_fee_percent),
      etopup_from_date: state?.etopup_from_date,
      etopup_to_date: state?.etopup_to_date,
      etopup_target_value: Number(state?.etopup_target_value) || null,
      bundle_from_date: state?.bundle_from_date,
      bundle_to_date: state?.bundle_to_date,
      bundle_target_value: Number(state?.bundle_target_value)
    };

    if (!id) {
      // Remove etopup_target_value from payload if it's 0
      if (Number(payload.etopup_target_value) == 0) delete payload.etopup_target_value;

      // Remove bundle_target_value from payload if it's 0 
      if (Number(payload?.bundle_target_value) == 0) delete payload?.bundle_target_value;

    } else {
      // Remove etopup_target_value from payload if it's 0
      if (Number(payload.etopup_target_value) == 0) payload.etopup_target_value = null;

      // Remove bundle_target_value from payload if it's 0 
      if (Number(payload?.bundle_target_value) == 0) payload.bundle_target_value = null;
    }

    // Set loading state to true before API call
    setLoading(true)

    // Make POST API call to create/update MNO with payload
    let response;
    if (id) {
      let editPayload = getChangedFields(temporaryState, payload)
      response = await PatchAPI(`mnos/${id}`, editPayload);
    } else {
      response = await PostAPI(`mnos/`, payload)
    }


    // If API call is successful
    if (!response?.error) {
      // Navigate to MNO list page after success
      navigate('/mno-management/list-of-mnos')

      // Dispatch success toast message
      dispatch(
        showToast({
          type: "success",
          // Show different message for edit vs create
          message: edit ? 'MNO details updated successfully' : response?.data?.message,
        })
      );

    } else {
      // Log error response for debugging
      console.log(response, 'API ERROR')

      // Dispatch error toast with message from API
      dispatch(
        showToast({
          type: "error",
          message: response?.data?.response?.data?.message,
        })
      );
    }

    // Set loading state back to false after API call completes
    setLoading(false)
  };

  // Function to fetch MNO details from API
  const getMNODetails = async () => {
    // Set loading state while fetching data
    setEditLoading(true)

    // Make API call to get MNO details using the id parameter
    let response = await getAPI(`mnos/${id}`)

    // Check if API call was successful
    if (!response?.error) {

      // Create object to store MNO details from API response
      let mnoDetails: addMNOtypes = {
        // Map basic MNO information
        subnet: response?.data?.data?.subnet,
        name: response?.data?.data?.name,
        contract_start_date: convertDate(response?.data?.data?.contract_start_date),
        contract_end_date: convertDate(response?.data?.data?.contract_end_date),
        // Convert numeric amounts to strings
        min_recharge_amount: (response?.data?.data?.min_recharge_amount).toString(),
        max_recharge_amount: (response?.data?.data?.max_recharge_amount).toString(),
        // Map address details
        office_no: response?.data?.data?.office_no,
        market_block_name: response?.data?.data?.market_block_name,
        floor_no: response?.data?.data?.floor_no,
        street_name: response?.data?.data?.street_name,
        city_town: response?.data?.data?.city_town,
        country: response?.data?.data?.country,
        province: response?.data?.data?.province,
        region: response?.data?.data?.region,
        district: response?.data?.data?.district,
        postal_code: response?.data?.data?.postal_code,
        // Convert eTopup fee percentages to strings
        etopup_upfront_fee_percent: (response?.data?.data?.etopup_upfront_fee_percent).toString(),
        etopup_target_fee_percent: (response?.data?.data?.etopup_target_fee_percent).toString(),
        etopup_principal_fee_percent: (response?.data?.data?.etopup_principal_fee_percent).toString(),
        etopup_dispersive_fee_percent: (response?.data?.data?.etopup_dispersive_fee_percent).toString(),
        // Convert bundle fee percentages to strings
        bundle_upfront_fee_percent: (response?.data?.data?.bundle_upfront_fee_percent).toString(),
        bundle_target_fee_percent: (response?.data?.data?.bundle_target_fee_percent).toString(),
        bundle_principal_fee_percent: (response?.data?.data?.bundle_principal_fee_percent).toString(),
        bundle_dispersive_fee_percent: (response?.data?.data?.bundle_dispersive_fee_percent).toString(),
        // Map eTopup target details
        etopup_from_date: convertDate(response?.data?.data?.etopup_from_date),
        etopup_to_date: convertDate(response?.data?.data?.etopup_to_date),
        etopup_target_value: (response?.data?.data?.etopup_target_value),
        // Map bundle target details
        bundle_from_date: convertDate(response?.data?.data?.bundle_from_date),
        bundle_to_date: convertDate(response?.data?.data?.bundle_to_date),
        bundle_target_value: (response?.data?.data?.bundle_target_value)
      };
      // Update main state with MNO details
      setState(mnoDetails);
      setDisablingState(mnoDetails);
      let tempMnoDetails: payload = {
        // Map basic MNO information
        subnet: response?.data?.data?.subnet,
        name: response?.data?.data?.name,
        contract_start_date: convertDate(response?.data?.data?.contract_start_date),
        contract_end_date: convertDate(response?.data?.data?.contract_end_date),
        // Convert numeric amounts to strings
        min_recharge_amount: (response?.data?.data?.min_recharge_amount),
        max_recharge_amount: (response?.data?.data?.max_recharge_amount),
        // Map address details
        office_no: response?.data?.data?.office_no,
        market_block_name: response?.data?.data?.market_block_name,
        floor_no: response?.data?.data?.floor_no,
        street_name: response?.data?.data?.street_name,
        city_town: response?.data?.data?.city_town,
        country: response?.data?.data?.country,
        province: response?.data?.data?.province,
        region: response?.data?.data?.region,
        district: response?.data?.data?.district,
        postal_code: response?.data?.data?.postal_code,
        // Convert eTopup fee percentages to strings
        etopup_upfront_fee_percent: (response?.data?.data?.etopup_upfront_fee_percent),
        etopup_target_fee_percent: (response?.data?.data?.etopup_target_fee_percent),
        etopup_principal_fee_percent: (response?.data?.data?.etopup_principal_fee_percent),
        etopup_dispersive_fee_percent: (response?.data?.data?.etopup_dispersive_fee_percent),
        // Convert bundle fee percentages to strings
        bundle_upfront_fee_percent: (response?.data?.data?.bundle_upfront_fee_percent),
        bundle_target_fee_percent: (response?.data?.data?.bundle_target_fee_percent),
        bundle_principal_fee_percent: (response?.data?.data?.bundle_principal_fee_percent),
        bundle_dispersive_fee_percent: (response?.data?.data?.bundle_dispersive_fee_percent),
        // Map eTopup target details
        etopup_from_date: convertDate(response?.data?.data?.etopup_from_date),
        etopup_to_date: convertDate(response?.data?.data?.etopup_to_date),
        etopup_target_value: (response?.data?.data?.etopup_target_value),
        // Map bundle target details
        bundle_from_date: convertDate(response?.data?.data?.bundle_from_date),
        bundle_to_date: convertDate(response?.data?.data?.bundle_to_date),
        bundle_target_value: (response?.data?.data?.bundle_target_value)
      };
      // Update temporary state with MNO details
      setTemporaryState(tempMnoDetails);

    } else {
      // Log error to console for debugging
      console.log(response, 'API ERROR')

      // Show error toast message to user
      dispatch(
        showToast({
          type: "error",
          message: response?.data?.response?.data?.message,
        })
      );
    }
    // Reset loading state after API call completes
    setEditLoading(false)
  }

  //Fetch MNO subnet list for the subnet dropdown
  const getSubnetList = async () => {
    let response = await getAPI(`mnos/subnets`);
    if (!response?.error) {
      let subnetList = response?.data?.data?.map((item: any) => item?.name)
      setSubnetList(subnetList);
    } else {
      console.log(response, 'API ERROR');
      dispatch(showToast({
        type: "error",
        message: response?.data?.response?.data?.message,
      }))
    }
  }

  // Fetch MNO details if id is present
  useEffect(() => {
    if (id) {
      getMNODetails();
    }
  }, [])

  useLayoutEffect(()=>{
    getSubnetList();
  },[])

  return (
    <>
      <Breadcrumbs
        navPath={["MNO Management", "List of MNO’s", `${!!id ? 'Edit' : 'Add'} MNO`]}
        heading={`${id ? "Edit" : "Add"} MNO`}
        noNavigation
        links={(pathname && id) ? [pathname, pathname] : ["/mno-management/list-of-mnos", "/mno-management/list-of-mnos"]}
      />
      <AddModel>
        <AddInputs
          inputs={MNODetailsinputs}
          totalInputCount={7}
          // isDisabledField={id ? ['email_address'] : []}
          inputValues={state}
          onInputChange={handleInputChange}
          mapping={true}
          RequiredPostalCode={true}
          errors={errors}
          editLoading={editLoading}
        />
        <h1 className='text-heading3 underline text-primary_text mb-6 mt-8' dir={notEnglish ? 'rtl' : 'ltr'}>Service Fee</h1>
        <AddInputs
          inputs={ServiceFeeDetailsinputs}
          totalInputCount={7}
          // isDisabledField={id ? ['email_address'] : []}
          inputValues={state}
          onInputChange={handleInputChange}
          mapping={true}
          RequiredPostalCode={true}
          errors={errors}
        // editLoading={editLoading}
        />
        <h1 className='text-heading3 underline text-primary_text mb-6 mt-8' dir={notEnglish ? 'rtl' : 'ltr'}>MNO Target</h1>
        <AddInputs
          inputs={MNOTargetDetails}
          totalInputCount={7}
          // isDisabledField={id ? ['email_address'] : []}
          inputValues={state}
          onInputChange={handleInputChange}
          mapping={true}
          RequiredPostalCode={true}
          errors={errors}
        // editLoading={editLoading}
        />
      </AddModel>
      <AddBottomButton
        buttonWidth={edit ? 'w-[140px]' : 'w-[140px]'}
        buttonName={`${!edit ? 'Add' : 'Update'} MNO`}
        buttonClass={`${edit ? 'w-[140px]' : 'w-[140px]'} whitespace-nowrap`}
        onClick={handleSubmit}
        disabled={edit ? deepEqual(state, disablingState) : false || loading}
        loading={loading}
        testID={edit ? 'edit_regional_office' : "add_regional_office"}
      />
    </>
  );
};

export default AddMNO;
